export default function(targetLang, currentHref) {
  const url = new URL(currentHref);
  const pathSegments = url.pathname.split("/").filter(Boolean);

  // Determine if the first segment is a locale to be replaced
  if (pathSegments.length > 0 && pathSegments[0] === window.appConfig.locale) {
    pathSegments[0] = targetLang;
  } else {
    pathSegments.unshift(targetLang);
  }

  url.pathname = "/" + pathSegments.join("/");
  return url.toString();
}
